module.exports = __webpack_public_path__ + "img/fif-weight.4d5f9f14.png";